"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/01/31
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessage = exports.system = void 0;
const tslib_1 = require("tslib");
const setup_1 = require("./setup");
const port_1 = require("./port");
Object.defineProperty(exports, "sendMessage", { enumerable: true, get: function () { return port_1.sendMessage; } });
const system_1 = tslib_1.__importDefault(require("./interfaces/system"));
exports.system = system_1.default;
(0, setup_1.init)();
tslib_1.__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map